import { render } from "./BlogRightSidebarPage.vue?vue&type=template&id=73f442d3"
import script from "./BlogRightSidebarPage.vue?vue&type=script&lang=js"
export * from "./BlogRightSidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__